
// vocabulary/mathematics.ts
import { VocabPair } from './types';

export const mathematics: VocabPair[] = [
  { word: "Algorithm", definition: "Step-by-step procedure for calculations" },
  { word: "Variable", definition: "Symbol representing an unknown number" },
  { word: "Equation", definition: "Mathematical statement showing equality" },
  { word: "Perimeter", definition: "Distance around the outside of a shape" },
  { word: "Probability", definition: "Likelihood that something will happen" },
  { word: "Integer", definition: "Whole number, positive or negative" },
  { word: "Fraction", definition: "Part of a whole number" },
  { word: "Geometry", definition: "Study of shapes and their properties" },
  { word: "Coefficient", definition: "Number multiplied by a variable" },
  { word: "Theorem", definition: "Mathematical rule that has been proven" },
  { word: "Parallel", definition: "Lines that never intersect" },
  { word: "Perpendicular", definition: "Lines that meet at right angles" },
  { word: "Circumference", definition: "Distance around a circle" },
  { word: "Diameter", definition: "Line through center of circle" },
  { word: "Radius", definition: "Distance from center to edge of circle" },
  { word: "Symmetry", definition: "Balanced proportions" },
];